import Recover from '@/views/recover/Index'
import { noAuthRoute } from '@/router/guards/auth'

export default {
  path: '/recover-password/:email/:key',
  name: 'recover-password',
  component: Recover,
  meta: {
    noAuth: true
  },

  beforeEnter (to, from, next) {
    const canEnter = noAuthRoute()

    if (canEnter) {
      return next(true)
    }
    
    next('/main')
  }
}